import React from 'react'

const Hidden = () => {
  return (
    <svg className="h-4 w-4 text-black hover:text-white" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z" />  <line x1="5" y1="12" x2="19" y2="12" /></svg>
  )
}

export default Hidden
